import { getTranslation } from "@mivo/i18n";
import { SUBSCRIPTION_TRANSLATIONS } from "@/domains/subscription/constants";

/** Canonical pt-BR string returned by the backend for payment-required blocks. */
export const PAYMENT_REQUIRED_DETAIL = SUBSCRIPTION_TRANSLATIONS.paymentRequiredDetail["pt-BR"];

export const PAYMENT_REQUIRED_REASON = "payment_required";

export function getPaymentRequiredMessage(): string {
    return getTranslation(SUBSCRIPTION_TRANSLATIONS.paymentRequiredDetail);
}

export function isPaymentRequiredDetail(detail: unknown): boolean {
    return detail === PAYMENT_REQUIRED_DETAIL;
}

export function isPaymentRequiredResponse(data: unknown): boolean {
    if (!data || typeof data !== "object") {
        return false;
    }

    const payload = data as { reason?: unknown; code?: unknown };
    return (
        payload.code === PAYMENT_REQUIRED_REASON ||
        payload.reason === PAYMENT_REQUIRED_REASON
    );
}
